<div class="d-flex justify-content-between gap-2 question-content-width"> 
  @for (label of question?.questionSpecificOptions?.labels; track label) {
  <span class="text-secondary-500 text-xs text-capitalize">{{ label?.text | titlecase }}</span>
  }
</div>
<div class="slider-container question-content-width">
  <!-- <span>{{ 1 }}</span> -->
  <input
    type="range"
    class="slider-input"
    [min]="min"
    [max]="max"
    [value]="value"
    [style.--slider-percentage]="((value - min) / (max - min)) * 100 + '%'"
    (input)="onSliderChange($event)"
    (click)="$event.stopPropagation()"
  />
  <span class="slider-max">{{ value }}</span>
</div>
